import { createStore } from "vuex";
import { auth } from "./auth.module";
import { wspace } from "/src/modules/workSpace/workSpace.store";  // src\modules\workSpace\workSpace.store.js
//src\store\auth.module.js
//src\modules\admin\admin.store.js
const store = createStore({
  modules: {
    auth,
    wspace,
  },
});

export default store;
